import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import { ResponseAddDto, ResponseEmpData, ResponseListingPerformanceEval } from "../../../shared/nestjs/gd-integrated/dto/performance-evaluation.dto";
import { ResponsePerformance } from "../../../shared/nestjs/gd-integrated/dto/performance-planning.dto";
import { PerformanceMonitoringApi } from "../../../shared/nestjs/gd-integrated/services/performance-monitoring.api";

@Injectable()
export class PerformanceMonitoringBloc {

  constructor(
    public performanceMonitoringApi: PerformanceMonitoringApi
  ) {
  }

  add(data): Observable<ResponseAddDto> {
		return this.performanceMonitoringApi.add(data);
	}

  listing(params, page, limit): Observable<ResponseListingPerformanceEval> {
		return this.performanceMonitoringApi.listing(params, page, limit);
  }
  
  history(requestNo, periodCode, empId, referenceDate, formNo): Observable<any> {
		return this.performanceMonitoringApi.history(requestNo, periodCode, empId, referenceDate, formNo);
  }

  empData(periodCode, empId): Observable<ResponseEmpData> {
		return this.performanceMonitoringApi.empData(periodCode, empId);
  }

  revisionHistory(formNo): Observable<ResponsePerformance> {
		return this.performanceMonitoringApi.revisionHistory(formNo);
  }

  revisionDetail(requestNo, periodCode, empId, referenceDate, formNo, reviewerEmpid): Observable<any> {
		return this.performanceMonitoringApi.revisionDetail(requestNo, periodCode, empId, referenceDate, formNo, reviewerEmpid);
  }

}



// WEBPACK FOOTER //
// ./src/bloc/hr/performance-sf6/performance-monitoring.bloc.ts